<template>
    <div>
        <b-form-select
            @change="updateValue()"
            :disabled="disabled"
            v-if="startTimes.length || disabled"
            v-model="localValue"
            :options="startTimes"
            :state="state"
        ></b-form-select>
        <div v-else class="text-muted small">
            <b-form-select>
                <option disabled selected>⚠️{{$t('No slots')}}</option>
            </b-form-select>
        </div>
    </div>
</template>

<script>
import sift from "sift";

export default {
    props: ['base', 'value', 'disabled', 'schedule', 'blocked', 'state'],
    data() {
        return {
            localValue: null,
            step: this.$settings.step,
            currentSchedule: {}
        }
    },
    watch: {
        // blocked(newValue) {
        //     console.log('data', newValue);
        //     this.blockedTimes(newValue);
        // },
        value(newVal) {
            let startDate = this.$moment(newVal).local();
            this.localValue = { 'hours': startDate.hours(), 'minutes': startDate.minutes() };
            this.getScheduleTimeinterval();
        },

        base(value) {
            this.updateValue();
            this.getScheduleTimeinterval();
        },
        schedule() {
            /* generate working hours depend on schedule */
            this.getScheduleTimeinterval();
        }
    },
    created() {
        let startDate = this.$moment(this.value).local();
        this.localValue = { 'hours': startDate.hours(), 'minutes': startDate.minutes() };
        this.getScheduleTimeinterval();

    },
    methods: {
        getScheduleTimeinterval() {
            if (!this.schedule) return;
            let dayOfWeek = this.$moment(this.base).locale('en').format('dddd');

            this.currentSchedule = this.schedule.filter(
                sift({ dayOfWeek: dayOfWeek.toLowerCase() })
            )[0];

        },
        updateValue() {
            let value = this.$moment(this.base).set({ 'hours': this.localValue.hours, 'minutes': this.localValue.minutes });
            this.$emit('input', value);
            this.$emit('change', value);
        },
        blockedTimes(data) {
            if (!data) { return; }
            let blockedSlots = [];

            data.forEach(blocked => {
                blocked.start = this.$moment(blocked.start);
                for (let minutes = blocked.start; minutes.isBefore(blocked.end); minutes.add(this.step, 'minutes')) {
                    blockedSlots.push({ hours: minutes.hour(), minutes: minutes.minutes() });
                }
            })
            return blockedSlots;
        },
    },
    computed: {
        startTimes() {
            let blockedSlots = this.blockedTimes(this.blocked);
            let data = [];
            if (!this.currentSchedule) return [];


            for (let hours = this.currentSchedule.startHour; hours < this.currentSchedule.endHour; hours++) {
                for (let minutes = 0; minutes < 60; minutes = minutes + this.step) {
                    let text = this.$moment().set({ 'hours': hours, 'minutes': minutes }).format('LT');

                    let itemIndex = blockedSlots.findIndex(row => JSON.stringify(row) === JSON.stringify({ hours, minutes }));
                    if (itemIndex >= 0) {
                        text = '⚠️ ' + text;
                    }

                    data.push({
                        text: text,
                        value: { hours, minutes }
                    });
                }
            }
            return data;
        }
    }

}
</script>
